import { render } from "./SubBanner.vue?vue&type=template&id=20ec939e&scoped=true"
import script from "./SubBanner.vue?vue&type=script&lang=js"
export * from "./SubBanner.vue?vue&type=script&lang=js"

import "./SubBanner.vue?vue&type=style&index=0&id=20ec939e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20ec939e"]])

export default __exports__